// Module
var code = "<div class=\"message\"><span ng-repeat=\"message in disconnectedMessages\">{{ message }}</span><front-royal-spinner></front-royal-spinner></div>";
// Exports
export default code;